import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import ProductGriditem from './ProductGridItem';
import GridLoading from './GridLoading';
const ProductsGrid = t0 => {
  const $ = _c(11);
  const {
    eagerImageCount: t1,
    productsData,
    loading,
    maxCardsCount: t2,
    layout: t3
  } = t0;
  const eagerImageCount = t1 === undefined ? 0 : t1;
  const maxCardsCount = t2 === undefined ? 0 : t2;
  const layout = t3 === undefined ? "" : t3;
  const placeholderCardsCount = maxCardsCount > productsData.length ? maxCardsCount - productsData.length : 0;
  if (loading) {
    let t4;
    if ($[0] !== placeholderCardsCount) {
      t4 = <GridLoading cardsCount={placeholderCardsCount} />;
      $[0] = placeholderCardsCount;
      $[1] = t4;
    } else {
      t4 = $[1];
    }
    return t4;
  }
  let t4;
  if ($[2] !== eagerImageCount || $[3] !== layout || $[4] !== productsData) {
    let t5;
    if ($[6] !== eagerImageCount || $[7] !== layout) {
      t5 = (productItem, idx) => <ProductGriditem key={`products-grid-item-${kebabCase(productItem.name)}`} eagerImageCount={eagerImageCount} productItem={productItem} idx={idx} layout={layout} />;
      $[6] = eagerImageCount;
      $[7] = layout;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = productsData.map(t5);
    $[2] = eagerImageCount;
    $[3] = layout;
    $[4] = productsData;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <>{t4}</>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
ProductsGrid.propTypes = {
  productsData: PropTypes.arrayOf(PropTypes.shape({
    campaign: PropTypes.string,
    enableMobileCarousel: PropTypes.bool,
    filterStateKey: PropTypes.string,
    hidden: PropTypes.bool,
    id: PropTypes.number.isRequired,
    initialOptionId: PropTypes.string,
    isClearance: PropTypes.bool,
    layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
    moreVariantsCount: PropTypes.number,
    name: PropTypes.string,
    onDisplayInShowroomSlug: PropTypes.string,
    path: PropTypes.string,
    position: PropTypes.number,
    productFamily: PropTypes.string,
    productLabel: PropTypes.string,
    productType: PropTypes.string,
    quickship: PropTypes.bool,
    secondaryImage: PropTypes.string,
    secondaryImageCropData: PropTypes.object,
    slug: PropTypes.string,
    variantsToShow: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      isOutOfStock: PropTypes.bool,
      label: PropTypes.string,
      minPrice: PropTypes.number,
      originalPrice: PropTypes.number,
      path: PropTypes.string.isRequired,
      price: PropTypes.number.isRequired,
      quickship: PropTypes.bool,
      sku: PropTypes.string
    })),
    variantsTotal: PropTypes.number
  })),
  loading: PropTypes.bool,
  layout: PropTypes.oneOf(['full', 'mini', 'minimal', 'minimal-with-attributes', 'minimal-with-showroom']),
  maxCardsCount: PropTypes.number
};
export default ProductsGrid;